import { withInstall } from '@ll-plus/utils'

import Tabs from './src/tabs.vue'

export const LlTabs = withInstall(Tabs)
export default LlTabs
export * from './src/tabs'

declare module 'vue' {
  export interface GlobalComponents {
    LlTabs: typeof Tabs
  }
}
